<!-- @prettier -->
<template>
  <Dialog
    header="New Version Available"
    class="p-dialog-375px"
    :visible="newVersionAvailableDialog.isVisible"
    @update:visible="refresh()"
  >
    <p>A new version of the WHQ Portal is available.</p>
    <template #footer>
      <Button
        label="Refresh"
        icon="material-symbols-outlined refresh"
        class="p-button-rounded"
        @click="refresh()"
      />
    </template>
  </Dialog>
</template>

<script setup>
  import { ref } from "vue";

  const newVersionAvailableDialog = ref({ isVisible: false });

  // add listener so that if the user tries to load any module that doesn't exist on the server, show this dialog
  // this happens if the user is on the site mid-deployment and they try to go to a page which is not cached in cloudfront
  window.addEventListener(
    "vite:preloadError",
    () => (newVersionAvailableDialog.value.isVisible = true)
  );

  const refresh = () => window.location.reload();
</script>
